var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckMark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 335.2 353.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112.2,325.3c-3.8,0-7.5-1.6-10.2-4.4L8.9,223.1c-5.4-5.6-5.1-14.5.5-19.9,5.6-5.3,14.5-5.2,19.9.5l82.2,86.3L307.1,51.6c4.9-6,13.8-6.9,19.8-2,6,4.9,6.9,13.8,2,19.8l-205.7,250.8c-2.6,3.1-6.3,5-10.4,5.1-.2,0-.3,0-.5,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/CheckMark.45893d80ab8aff1d7e1601bad1faf370.svg";
export { ForwardRef as ReactComponent };